import Vue from 'vue';

const pendingCleanupDeps: any[] = [];
let cleanupScheduled = false;

const cleanupDeps = () => {
    cleanupScheduled = false;
    for (let i = 0; i < pendingCleanupDeps.length; i++) {
        const dep = pendingCleanupDeps[i];
        dep.subs = dep.subs.filter((s: any) => s);
        dep._pending = false;
    }
    pendingCleanupDeps.length = 0;
};

// The removal algorithm of Vue 2.7.16 (vuejs/vue#12696) for Vue 2.6: removing one subscriber from a dependency with a great many of
// them is very slow in Chromium, so removal leaves a hole and the holes are cleared later. Upstream clears them after its scheduler
// flush, which is not reachable from here, so this does it in a task of its own. Remove this file when moving to Vue 2.7.
const probe: any = new Vue({ data: { value: 1 } });
const depPrototype = probe.$data.__ob__.dep.constructor.prototype;
probe.$destroy();

depPrototype.removeSub = function (sub: any) {
    this.subs[this.subs.indexOf(sub)] = null;
    if (!this._pending) {
        this._pending = true;
        pendingCleanupDeps.push(this);
        if (!cleanupScheduled) {
            cleanupScheduled = true;
            setTimeout(cleanupDeps, 0);
        }
    }
};

depPrototype.notify = function () {
    const subs = this.subs.filter((s: any) => s);
    if (process.env.NODE_ENV !== 'production' && !Vue.config.async) {
        subs.sort((a: any, b: any) => a.id - b.id);
    }
    for (let i = 0, l = subs.length; i < l; i++) {
        subs[i].update();
    }
};
